import { Box, useTheme } from "@mui/material";

import { RobotoTypography } from "@/shared/components";
import { Goto } from "@/shared/navigation/Goto";

import { SettingsPageLayout } from "../SettingsPageLayout";

import { IntegrationCard } from "./IntegrationCard";
import { FoxgloveIcon, S3Icon, SlackIcon } from "./IntegrationIcon";

export function Integrations() {
  const theme = useTheme();

  return (
    <SettingsPageLayout>
      <RobotoTypography variant="body1" sx={{ mb: 3 }}>
        Connect Roboto with your favorite tools and services to streamline your
        robotics data workflows.
      </RobotoTypography>

      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: {
            xs: "1fr",
            sm: "repeat(auto-fit, minmax(350px, 1fr))",
          },
          gap: theme.spacing(3),
          mt: 2,
        }}
      >
        <IntegrationCard
          name="AWS S3"
          description="Connect your existing S3 bucket to store and manage your robotics data."
          status="available"
          href={Goto.route.S3Integration}
          icon={<S3Icon size={40} />}
        />

        <IntegrationCard
          name="Foxglove"
          description="Automatically import and process robotics data from your Foxglove recordings."
          status="available"
          href="/integrations/foxglove"
          icon={<FoxgloveIcon size={40} />}
        />

        <IntegrationCard
          name="Slack"
          description="Get notifications and updates about your robotics data processing directly in Slack."
          status="coming-soon"
          icon={<SlackIcon size={40} />}
        />
      </Box>
    </SettingsPageLayout>
  );
}
